export const snakeToCamel = (str) => str.replace(
    /([-_][a-z])/ig,
    (group) => group.toUpperCase()
    .replace('-', '')
    .replace('_', '')
);

export const scrollTo = (element) => {
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop
    });
}